module.exports = __webpack_public_path__ + "img/keycap-digit-two.2b5e895d.png";